import React, { useState, useContext} from "react";
import "../style/login.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import background from "../images/background2.jpg";
import LOGOJI from "../images/RKLOGO.png";
import { Alert } from "react-bootstrap";
import { BASE_URL } from "../utils/config";
import { CredentialComponent } from "../components/credentials";
import { Link, useNavigate } from "react-router-dom";


const NewLogin = () => {
    const [loginData, setLoginData] = useState({
        username: "",
        password: "",
      });
      
      const { isAuthenticated, setIsAuthenticated } =
        useContext(CredentialComponent);
      const [showInvalidPasswordAlert, setShowInvalidPasswordAlert] =
        useState(false);
      const [showErrorAlert, setshowErrorAlert] = useState(false);
      const [errorMessage,setErrorMessage]=useState('')
      const passwordRegex =
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+[\]{};:<>?]{8,}$/;
    
      const navigate = useNavigate();
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setLoginData({
          ...loginData,
          [name]: value,
        });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        // Do something with the form data, e.g., send it to an API
        console.log(loginData);
    
        try {
          if (
            loginData.username === "" ||
            loginData.username == null ||
            loginData.password === "" ||
            loginData.password == null
          ) {
            setErrorMessage('Fields cannot be empty.')
            setshowErrorAlert(true);
            
            setTimeout(() => {
              setshowErrorAlert(false);
            }, 1500);
          } else if (!passwordRegex.test(loginData.password)) {
            setShowInvalidPasswordAlert(true);
            setTimeout(() => {
              setShowInvalidPasswordAlert(false);
            }, 5000);
          } else {
            let body = JSON.stringify({ logindetails: loginData });
            fetch(`${BASE_URL}/login`, {
              method: "POST",
              body,
              headers: {
                "Content-Type": "application/json",
              },
            })
              .then((res) => res.json())
              .then((res) => {
                console.log("res", res);
                if (res.success === true) {
                   
                
                  let userdata = res.userData[0];
                  console.log("userdata", userdata);
                  let loginData = res.loginDetail[0]
                  console.log("loginData",loginData)
    
                  if (userdata.force_password_change_options_on_sign_in == 0) {
                    localStorage.setItem("userdetails", JSON.stringify(userdata));
    
                    navigate("/forgotpassword", {
                      state: { show: "changepassword",EditscreenUserDetails:userdata},
                    });
                  } else if (userdata.role_type === "SuperAdmin") {
                    console.log("admin user");
                    localStorage.setItem("data", true);
                    localStorage.setItem("userdetails", JSON.stringify(userdata));
                    localStorage.setItem("loginData", JSON.stringify(loginData));
                    localStorage.setItem("roleType", JSON.stringify("SuperAdmin"));
                    setIsAuthenticated(true);
                    navigate("/home");
                  } else if(userdata.role_type === "Supervisor"){
                    console.log("Supervisor");
                    localStorage.setItem("userdetails", JSON.stringify(userdata));
                    localStorage.setItem("loginData", JSON.stringify(loginData));
                    localStorage.setItem("data", true);
                    localStorage.setItem("roleType", JSON.stringify("Supervisor"));
                    
                    setIsAuthenticated(true);
                    navigate('/home');
                  }
                  else if(userdata.role_type === "User"){
                    console.log("normal user");
                    localStorage.setItem("userdetails", JSON.stringify(userdata));
                    localStorage.setItem("loginData", JSON.stringify(loginData));
                    localStorage.setItem("data", true);
                    localStorage.setItem("roleType", JSON.stringify("User"));
                    
                    setIsAuthenticated(true);
                    navigate('/home');
                  } else if(userdata.role_type === "MCXUser"){
                    console.log("MCXUser==========");
                    localStorage.setItem("userdetails", JSON.stringify(userdata));
                    localStorage.setItem("loginData", JSON.stringify(loginData));
                    localStorage.setItem("data", true);
                    localStorage.setItem("roleType", JSON.stringify("MCXUser"));
                    
                    setIsAuthenticated(true);
                    navigate('/mcxdashboard');
                  }
                  else{
                   
                    setErrorMessage(res.message)
            setshowErrorAlert(true);
            
            setTimeout(() => {
              setshowErrorAlert(false);
            }, 1500);
                  }
                } else {
                // console.log("message",res.message);
                setErrorMessage(res.message)
            setshowErrorAlert(true);
            
            setTimeout(() => {
              setshowErrorAlert(false);
            }, 1500);
                }
              }).catch((error)=>{
                setErrorMessage(error.message)
            setshowErrorAlert(true);
            
            setTimeout(() => {
              setshowErrorAlert(false);
            }, 1500);
              })
          }
        } catch (error) {
          console.log("error", error);
          setErrorMessage(error.message)
            setshowErrorAlert(true);
            
            setTimeout(() => {
              setshowErrorAlert(false);
            }, 1500);
        }
      };


    
  return (
    <div className="newlogin">
    <img src={background} alt="" className="loginBg"  style={{width:"550px", marginLeft:"15%"}}/>
      <div className="box" style={{marginLeft:"11%"}}>
        <span className="borderLine"></span>
       

        <form onSubmit={handleSubmit}>
      {/* Your existing code for the logo and alert */}
      <a className="logo-container" href="https://www.iamrakeshbansal.com/" style={{ position: "absolute", top: "-2px", left: "20px", marginLeft: "32%", width: '100px' }}>
        <img src={LOGOJI} alt="RNR Logo" className="LOGO" />
      </a>

      {showErrorAlert && (
        <Alert variant="danger" onClose={() => setshowErrorAlert(false)} dismissible>
          {errorMessage}
        </Alert>
      )}

      <h2 style={{ marginTop: "15px" }}>Sign In</h2>

      <div className="inputBox">
        {/* <input type="text" name="username" required="required" /> */}
        <input
              
              type="text"
              name="username"
              id="username"
              onChange={handleChange}
            />
        <span>Username</span>
        <i></i>
      </div>
      <div className="inputBox">
        {/* <input type="password" name="password" required="required" /> */}
        {showInvalidPasswordAlert && (
              <Alert
                variant="danger"
                onClose={() => setShowInvalidPasswordAlert(false)}
                dismissible
              >
                Please enter a valid password. Passwords must be at least 8
                characters long and contain at least one letter, one digit, and
                may include special characters.
              </Alert>
            )}
            <input
              
              type="password"
              name="password"
              id="password"
              onChange={handleChange}
            />
        <span>Password</span>
        <i></i>
      </div>

      <div style={{ marginTop: "20px" }}>
        <Link
        className="link-forgotpassword"
          to="/forgotpassword"
          state={{ show: "forgotpassword" }}
          style={{ textDecoration: "underline", color: "blue" }}
        >
          Forgot Password?
        </Link>
      </div>

                  {/* <MicrosoftLogin
                    clientId={microsoftClientId}
                    // authCallback={authHandler}
                    authCallback={(error, data, msal) => authHandler(error, data, msal)}
                    withUserData={true}
                    graphScopes={["user.read"]}
                   // buttonTheme={"dark"}
                  /> */}
      <input type="submit" value="Login" />
    </form>
      </div>
    </div>
  );
};

export default NewLogin;
